import React, { forwardRef } from 'react';

import styles from './Card.module.css';

export interface CardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
    variant?: 'default' | 'flat' | 'outline' | 'interactive';
    padding?: 'none' | 'small' | 'medium' | 'large';
    hoverable?: boolean;
    clickable?: boolean;
    title?: React.ReactNode;
    footer?: React.ReactNode;
}

const Card = forwardRef<HTMLDivElement, CardProps>(({
    children,
    variant = 'default',
    padding = 'medium',
    hoverable = false,
    clickable = false,
    onClick,
    className = '',
    title,
    footer,
    ...props
}, ref) => {
    const cardClasses = [
        styles.card,
        styles[variant],
        styles[`padding-${padding}`],
        hoverable && styles.hoverable,
        clickable && styles.clickable,
        className
    ].filter(Boolean).join(' ');

    return (
        <div
            ref={ref}
            className={cardClasses}
            onClick={clickable ? onClick : undefined}
            role={clickable ? 'button' : undefined}
            tabIndex={clickable ? 0 : undefined}
            {...props}
        >
            {title && <div className={styles.cardTitle}>{title}</div>}
            {children}
            {footer && <div className={styles.cardFooter}>{footer}</div>}
        </div>
    );
});

Card.displayName = 'Card';

export default Card;
